import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IdentityProvider, ItonicsAuthService } from '../../../services/itonicsAuth.service';
import { p } from '../../../../../node_modules/@angular/core/src/render3';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  isLoginError: Boolean = false;

  isGoogleEnabled: Boolean = false;

  isSamlEnabled: Boolean = false;

  error = '';

  constructor(
    private itonicsAuthService: ItonicsAuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.error) {
        this.toastr.error(params.error);
      }
    });

    this.itonicsAuthService.isAuthenticated({
      isLoggedIn: (message, loggedIn) => {
        if (loggedIn) {
          // redirect to home page
          this.router.navigate(['/home']);
        }
      }
    });

    this.itonicsAuthService.getProviders().subscribe(
      (providers: IdentityProvider[]) => {
        this.isGoogleEnabled = providers.findIndex((provider) => provider.providerName === 'Google') !== -1;
        this.isSamlEnabled = providers.findIndex((provider) => provider.providerType === 'SAML') !== -1;
      },
      (error) => this.toastr.error(error)
    );
  }

  samlSignIn() {
    window.location.href = this.itonicsAuthService.getSignInUrlForClient();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/user/sign-in/sign-in.component.ts